module.exports = __webpack_public_path__ + "img/plan-2-b1.1e95face.png";